// hiding list items over X

bq.hideMaxList = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.totalListItems = 0;
  this.speedPerLI = 0;
  this.moreLink = '';

};

bq.hideMaxList.DEFAULTS = {
  max: 3,
  speed: 1000,
  moreText: bq.messages.global.show, //[COUNT] will be replaced with actual count
  lessText: bq.messages.global.hide,
  activeClass: 'active',
  activeOnLoad: false,
  linkTemplate:'<li class="show-link"><a href="javascript:void(0);"></a></li>'
};

bq.hideMaxList.prototype = {
  init: function() {
    bq.debug.log("Hide Max List : init()", this.$element);

    this.totalListItems = this.$element.children("li").length;

    //calculate speed
    if (this.totalListItems > 0 && this.options.speed > 0) {
      this.speedPerLI = Math.round(this.options.speed / this.totalListItems);
      if (this.speedPerLI < 1) { this.speedPerLI = 1; }
    } else {
      this.speedPerLI = 0;
    }

    if((this.totalListItems > 0) && (this.totalListItems > (this.options.max + 1))) { //if there are more then allowed
      this.createLink();

      if(this.options.activeOnLoad) {
        this.updateLink(true);
      } else {
        this.hideListItems(true);
      }
    }

  },

  hideListItems: function(firstLoad) {
    var listElements = this.$element.find('li').not('.show-link');
    listElements = listElements.slice(this.options.max);

    if(firstLoad || this.speedPerLI === 0) {
      listElements.hide(0);
    } else {
      var $this = this;
      var i = listElements.length - 1;
      (function hideListRecur() { $(listElements[i--] || []).slideToggle($this.speedPerLI,hideListRecur); })();
    }
  },

  showListItems: function() {
    var listElements = this.$element.find('li').not('.show-link');
    listElements = listElements.slice(this.options.max);

    if(this.speedPerLI === 0) {
      listElements.show(0);
    } else {
      var $this = this;
      var i = 0;
      (function showListRecur() { $(listElements[i++] || []).slideToggle($this.speedPerLI,showListRecur); })();
    }
  },

  createLink: function() {
    var howManyMore = this.totalListItems - this.options.max;
    var newMoreText = this.options.moreText;
    var newLessText = this.options.lessText;

    if (howManyMore > 0){
      newMoreText = newMoreText.replace("[COUNT]", howManyMore);
      newLessText = newLessText.replace("[COUNT]", howManyMore);
    }

    var tmpEl = $(this.options.linkTemplate);
    tmpEl.find('a').text(newMoreText);
    tmpEl.data('more', newMoreText);
    tmpEl.data('less', newLessText);

    this.moreLink = tmpEl;
    this.moreLink.on('click', {thiz: this}, this.handleEventClickLink);
    this.$element.append(tmpEl);

  },

  updateLink: function(active) {
    if(active) {
      this.moreLink.addClass(this.options.activeClass).find('a').text(this.moreLink.data('less'));
    } else {
      this.moreLink.removeClass(this.options.activeClass).find('a').text(this.moreLink.data('more'));
    }
  },

  handleEventClickLink: function(e) {
    var $this = e.data.thiz;
    if($this.moreLink.hasClass($this.options.activeClass)) {
      $this.updateLink(false);
      $this.hideListItems();
    } else {
      $this.updateLink(true);
      $this.showListItems();
    }
  }

};

// HIDE MAX LIST PLUGIN DEFINITION
// =======================

var hideMaxListold = $.fn.hideMaxList;

$.fn.hideMaxList = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.hideMaxList');
    var options = $.extend({}, bq.hideMaxList.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.hideMaxList', (data = new bq.hideMaxList(this, options))); }
    data.init();
  });
};

$.fn.hideMaxList.Constructor = bq.hideMaxList;

// HIDE MAX LIST NO CONFLICT
// =================

$.fn.hideMaxList.noConflict = function () {
  $.fn.hideMaxList = hideMaxListold;
  return this;
};

// HIDE MAX LIST DATA-API
// ==============

bq.hideMaxListInit = function() {
  $('[data-bq="hide-max"]').each(function () {
    var el = $(this);
    if(el.data('bq.hideMaxList')) { return; }
    el.hideMaxList(el.data());
  });
};

bq.init.push(bq.hideMaxListInit);
